import { render, staticRenderFns } from "./LogosItem.vue?vue&type=template&id=999d9fb8&scoped=true&"
import script from "./LogosItem.vue?vue&type=script&lang=ts&"
export * from "./LogosItem.vue?vue&type=script&lang=ts&"
import style0 from "./LogosItem.vue?vue&type=style&index=0&id=999d9fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999d9fb8",
  null
  
)

export default component.exports